import { Card, Media } from '../../components/ui'
import { StarRating } from './StarRating'
import type { Review } from '../../types/storefront'

/** created_at is an ISO string from the API; anything unparseable is dropped
 *  rather than shown as "Invalid Date". */
function formatDate(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleDateString('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function ReviewCard({ review }: { review: Review }) {
  const date = formatDate(review.created_at)

  return (
    <Card variant="tonal" className="flex h-full flex-col gap-4">
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-surface-container-high">
          <Media src={review.avatar} alt="" kind="person" />
        </div>
        <div className="min-w-0">
          <p className="truncate font-body-md text-body-md text-on-surface">{review.customer_name}</p>
          {date && <p className="font-label-caps text-label-caps uppercase text-on-surface-variant">{date}</p>}
        </div>
      </div>

      <StarRating value={review.rating} />

      {review.comment && (
        <p className="font-body-md text-body-md text-on-surface-variant">&ldquo;{review.comment}&rdquo;</p>
      )}
    </Card>
  )
}
